import { t } from 'i18next';
import { useEffect, useState } from 'react';

import { callTransferFailed } from 'features/call/call-ui-state/store';
import { sipCallIdSelector } from 'features/call/call-base/store/selectors';
import { secondsToMs } from 'common/helpers';
import { AppSupportedLanguage } from 'config/enums';
import { DEFAULT_HANDOFF_ANSWER_TIMEOUT_SEC } from 'features/app-config/constants';
import { handleError } from 'features/notification/store';
import { useReceivedEventTimeout } from 'common/hooks';
import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { handleResetCall } from 'features/call/call-base/store';
import { RnsEventBus } from 'features/call/call-events';
import { completeColdHandoff } from 'features/cold-handoff/store';
import { useWhileComponentMounted } from 'features/utils/hook';
import { resetVriChat } from 'features/vri-chat/store';

export const useColdHandoffTakenRnsHandlers = () => {
  const dispatch = useAppDispatch();
  const sipCallId = useAppSelector(sipCallIdSelector);
  const whileComponentMounted = useWhileComponentMounted();
  const { setTimeout } = useReceivedEventTimeout();
  const [isHandoffSentReceived, setIsHandoffSentReceived] = useState(false);

  const handleColdHandoffSent = () => {
    setIsHandoffSentReceived(true);
    setTimeout(
      handleColdHandoffCallNotReceived,
      secondsToMs(DEFAULT_HANDOFF_ANSWER_TIMEOUT_SEC)
    );
  };

  const handleColdHandoffCallNotReceived = () => {
    dispatch(
      handleError({
        error: t('handoffNotReceived', { lng: AppSupportedLanguage.EN }),
        title: t('handoffNotReceived'),
        methodName: 'handleColdHandoffCallNotReceived',
        disableUserNotification: true,
      })
    );
    dispatch(callTransferFailed());
  };

  useEffect(() => {
    if (sipCallId) {
      dispatch(completeColdHandoff());
    }
  }, [dispatch, sipCallId]);

  const handleColdHandoffCanceled = () => {
    dispatch(handleResetCall()).unwrap();
    dispatch(resetVriChat());
  };

  useEffect(() => {
    RnsEventBus.$coldHandoffSent
      .pipe(whileComponentMounted())
      .subscribe(handleColdHandoffSent);

    RnsEventBus.$coldHandoffCanceled
      .pipe(whileComponentMounted())
      .subscribe(handleColdHandoffCanceled);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isHandoffSentReceived };
};
